/** Keep retry keys for ambiguous failures without storing transaction payloads. */
const pending = new Map<string,{key:string;at:number}>();
export function isPostingRequest(method?:string,url?:string):boolean {
 return method?.toLowerCase()==="post" && /^(?:\/?)(sale|purchase|inventory-count|inventory-transfer)\/(Save|Update|CreateReturn|ApproveOrReject|PostInventory)/i.test(url??"");
}
export async function operationKey(scope:string,url:string,data:unknown):Promise<string> {
 const payload=`${scope}|${url}|${typeof data==="string"?data:JSON.stringify(data??null)}`;
 const bytes=await crypto.subtle.digest("SHA-256",new TextEncoder().encode(payload));
 const fingerprint=Array.from(new Uint8Array(bytes),x=>x.toString(16).padStart(2,"0")).join("");
 for(const [id,entry] of pending)if(Date.now()-entry.at>600000)pending.delete(id);
 const existing=pending.get(fingerprint);if(existing)return existing.key;
 while(pending.size>=100)pending.delete(pending.keys().next().value!);
 const key=crypto.randomUUID();pending.set(fingerprint,{key,at:Date.now()});return key;
}
export function completeOperation(key?:string):void {if(key)for(const [id,entry]of pending)if(entry.key===key)pending.delete(id);}
